import { AxiosInstance } from "axios";
import { IResponseBody } from "../../Schemas/EndPoint";
import { FileSchema } from "../../Schemas/File";

export interface FileListResponseBody extends IResponseBody {
  data: {
    files: FileSchema;
  };
}


export interface FileRejectionRequestBody {
  description: string;
}

export class FileRejectRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath(fileId: number) {
    return `admin/files/${fileId}/reject`;
  }

  async send(fileId: number, payload:FileRejectionRequestBody): Promise<FileListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath(fileId),
        payload
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
